import { styled } from "~/application/theme";

export const ScrollContainer = styled("div", {
  display: "flex",
  gap: "$3",
  overflowX: "auto",
  scrollSnapType: "x mandatory",
  "-webkit-overflow-scrolling": "touch",
  position: "relative",

  "&::-webkit-scrollbar": { display: "none" },
  "-ms-overflow-style": "none",
  "scrollbar-width": "none",
});

export const GradientOverlay = styled("div", {
  position: "absolute",
  top: 0,
  height: "100%",
  width: "24px",
  pointerEvents: "none",
  zIndex: 10,

  variants: {
    direction: {
      left: {
        left: 0,
        background: "linear-gradient(to right, $colors$background, transparent)",
      },
      right: {
        right: 0,
        background: "linear-gradient(to left, $colors$background, transparent)",
      },
    },
  },
});
